"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AvatarBadge = void 0;
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _AvatarBadge = require("./AvatarBadge.styles");
var _excluded = ["icon"];
/**
 * See `BadgedAvatar`
 *
 * @since 7.18.0
 */
var AvatarBadge = function AvatarBadge(_ref) {
  var icon = _ref.icon,
    rest = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  return /*#__PURE__*/_react.default.createElement(_AvatarBadge.StyledAvatarBadge, rest, icon);
};
exports.AvatarBadge = AvatarBadge;
AvatarBadge.displayName = 'AvatarBadge';
AvatarBadge.propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   * The size of the badge. Note: badges should not be used at `'xs'`, `'sm'` and `'md'` sizes.
   */
  size: _propTypes.default.oneOf(['xxl', 'xl', 'lg']),
  /**
   * The badge icon.
   */
  icon: _propTypes.default.node.isRequired
} : {};
AvatarBadge.defaultProps = {
  size: 'lg'
};